module.exports = __webpack_public_path__ + "cachable/fonts/fa-regular-400.a3d7d331957546ae10ad69bb44b83a04.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.woff2
// module id = 1186
// module chunks = 0